export const PRIVACY_CHOICES_LABEL = "Your Privacy Choices";
